<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				label="流程"
				placeholder="选择流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择流程' }]"
			/>
			<van-field
				v-model="form.xmgc"
				label="项目名称"
				placeholder="输入项目名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入项目名称' }]"
			/>
			<van-field
				v-model="form.khh"
				label="开户行"
				placeholder="输入开户行"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入开户行' }]"
			/>
			<van-field
				v-model="form.je"
				label="金额"
				placeholder="输入金额"
				type="numbner"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入金额' }]"
			/>
			<van-field
				v-model="form.kksy"
				label="付款事由"
				placeholder="输入付款事由"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入付款事由' }]"
			/>
			<van-field
				v-model="form.zbdljglxfs"
				label="招标代理机构联系方式"
				placeholder="输入招标代理机构联系方式"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入招标代理机构联系方式' }]"
			/>
			<van-field
				v-model="form.skzh"
				label="收款账号"
				placeholder="输入收款账号"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入收款账号' }]"
			/>
			<van-field
				v-model="form.zbdljgskdw"
				label="招标代理机构收款单位"
				placeholder="输入招标代理机构收款单位"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入招标代理机构收款单位' }]"
			/>
			<van-field
				v-model="form.xmbh"
				label="项目编号"
				placeholder="输入项目编号"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入项目编号' }]"
			/>
			<van-field
				v-model="form.tbgsmc"
				label="投标公司名称"
				placeholder="输入投标公司名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入投标公司名称' }]"
			/>
			<van-field
				v-model="form.gxmbsgmhtbr"
				label="标书购买和投标人"
				placeholder="输入标书购买和投标人"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入标书购买和投标人' }]"
			/>
			<van-field
				v-model="form.remark"
				rows="3"
				autosize
				label="备注"
				type="textarea"
				placeholder="请输入备注"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入备注' }]"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="popup.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
	</div>
</template>

<script>
import { getList } from "@/api/review";
import { Toast } from "vant";

export default {
	name: "margin",
	data() {
		return {
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			form: {
				xmgc: "",
				khh: "",
				je: "",
				kksy: "",
				zbdljglxfs: "",
				skzh: "",
				xmbh: "",
				tbgsmc: "",
				gxmbsgmhtbr: "",
				remark: ""
			},
			processList: [],
			popup: {
				process: false
			}
		};
	},
	mounted() {
		this.getMarginList();
	},
	methods: {
		onSubmit() {
			this.$emit("sub", {
				requestType: "process_apply",
				process_id: this.process_id,
				apply_data: JSON.stringify(this.form),
				apply_rmb:  this.form.je
			});
		},
		getMarginList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		}
	}
};
</script>